import { Component, OnInit, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-app-layout",
  templateUrl: "./app-layout.component.html",
})
export class AppLayoutComponent implements OnInit {
  @Output() sidemenuToggle = new EventEmitter<boolean>();

  showhideSideMenu = true ? false : true;

  constructor() {}

  ngOnInit() {}

  sideMenuChange(val) {
    this.showhideSideMenu = val;
  }

  toggleSidemenu() {
    this.sidemenuToggle.emit((this.showhideSideMenu = false));
  }
}
